import Types from '../../types/participants';

const initialState = {
  participantRollSheets: {
    loading: false,
    data: {},
    error: '',
  },
  participantRollSheetSlots: {
    loading: false,
    data: {},
    error: '',
  },
};

export default function ParticipantRollSheet(state = initialState, action) {
  switch (action.type) {
    case Types.GET_PARTICIPANT_ROLL_SHEETS_REQUEST:
      return {
        ...state,
        participantRollSheets: {
          ...state.participantRollSheets,
          loading: true,
        },
      };
    case Types.GET_PARTICIPANT_ROLL_SHEETS_SUCCESS:
      return {
        ...state,
        participantRollSheets: {
          error: '',
          loading: false,
          data: action.payload,
        },
      };
    case Types.GET_PARTICIPANT_ROLL_SHEETS_ERROR:
      return {
        ...state,
        participantRollSheets: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    default:
      return state;
  }
}
